import { env } from '@/config/env';
import { WEBSITE_ROUTES } from '@/constants/routes';

export const authWithToken = (token: string, path = WEBSITE_ROUTES.PROFILE) => {
  const url = `${env.WEBSITE_URL}${path}/?auth_token=${encodeURIComponent(token)}`;
  window.open(url, '_blank');
};
